import { UseInfiniteQueryOptions, useInfiniteQuery } from '@lumapps/base-api/react-query';

import { askAiRulesQueryKeys, listAskAiRules } from '../api';
import { ListRulesParamsDTO } from '../types';

export const useAskAiInfiniteRules = (listRulesParams: ListRulesParamsDTO, options?: UseInfiniteQueryOptions) => {
    const params = { ...listRulesParams };
    return useInfiniteQuery({
        ...options,
        queryKey: askAiRulesQueryKeys.rules(params),
        queryFn: ({ signal, pageParam }) => listAskAiRules({ ...params, cursor: pageParam }, signal),
        getNextPageParam: (lastPage) => lastPage?.more && lastPage?.cursor,
    });
};
